import { render, staticRenderFns } from "./TopPlaysCLient.vue?vue&type=template&id=e6183c74&scoped=true"
import script from "./TopPlaysCLient.vue?vue&type=script&lang=js"
export * from "./TopPlaysCLient.vue?vue&type=script&lang=js"
import style0 from "./TopPlaysCLient.vue?vue&type=style&index=0&id=e6183c74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6183c74",
  null
  
)

export default component.exports